import styled from 'styled-components';
import { palette } from 'styled-theme';
import iPhoneXbg from '../../image/roi/iPhone-X-Mockup-inside.png';

const WidgetWrapper = styled.div`
  margin: 0 10px;

  @media only screen and (max-width: 767) {
    margin-right: 0 !important;
  }
`;

const WidgetBox = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px;
  background-color: #ffffff;
  border: 1px solid${palette('border', 2)};

  canvas {
    width: 100% !important;
    height: 100% !important;
  }

  .trackingAccount {
    max-width: 180px;
    max-height: 46px;
    padding: 4px;
  }
`;

const WidgetColumn = styled.div`align-content: flex-start;`;


const DashboardWrapper = styled.div`

.dashboard-tooltip {
  display: inline-block;
  margin-left: 4px;
  border: 1px solid rgba(147, 147, 147, 1);
  border-radius: 100%;
  width: 14px; height: 14px;
  line-height: 14px;
  font-family: 'Montserrat';
  text-align: center;
  font-size: .7em;
  color: rgba(147, 147, 147, 1);
}

.exampleHolder > div {
  margin-left: auto;
  margin-right: auto; 
}
@media (min-width: 768px) {
  .exampleHolder {
  position: absolute;
  width: 80%;
  right: 0;
  } 
}

.exampleHolder2 {
  position: absolute;
  padding: 6%;
}

@media (min-width: 850px) {
  .exampleHolder {
      // width: 100%; 
  } 
}

.header {
  position:relative;
  background-color: rgba(35, 31, 32, 1);
  padding: 29px;
  .greenLogo{
      margin-left: auto;
      margin-right: auto;    
      height: 77px;
      width: 118px;
  }
  .greenLogo { height: auto; }
}
.header:after {
  position: absolute;
  display: inline-block;
  content: '';
  right: 0; bottom: -3px; left: 0;
  height: 3px;
  background-color: rgba(12, 183, 148, 1);
  z-index: 1;
}

.footer {
    background-color: rgba(35, 31, 32, 1);
    padding: 17px;
    .footerTitle{
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        letter-spacing: 0.07em;
    }
}

.iPhone{
  width: 100%;
  backgroundImage: "url(" + { Background } + ")"
  
}


.adExample__ad-example {
  width: 100%;
  max-width: 22rem;
  overflow: hidden;
  position: relative;
  margin-top: 3rem;
  }
  @media (min-width: 768px) {
    .adExample__ad-example {
      margin-top: 0;
      margin-right: 0; } }
  @media (min-width: 1281px) {
    .adExample__ad-example {
      /* max-width: 24rem; */
      } }
  .adExample__ad-example.centered__ad-example {
    margin-left: auto;
    margin-right: auto; }



.container__ad-example {
  position: absolute;
  top: 34.15133%;
  width: 88.03030303030303%;
  left: 6.1%; }

.adExampleFull__ad-example .container__ad-example {
  top: 18.759231905465288%; }

.searchTerm__ad-example {
  position: absolute;
  top: 10.4%;
  left: 18.2%;
  font-size: 0.7rem; }
  @media (min-width: 480px) {
      .searchTerm__ad-example {
      font-size: 0.8rem; } }


.app__ad-example {
  padding: 3.787878787878788%;
  background: #fff; }
  
.app__ad-example.isAd__ad-example {
  background: #EDF6FF; }


.appSummary__ad-example {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center; }

.appThumbnail__ad-example {
  width: 27.03583%;
  margin-right: 2.9316%;
  -ms-flex-negative: 0;
      flex-shrink: 0; }
.appThumbnail__ad-example > img {
  border-radius: 16px; }

.appName__ad-example {
  font-size: 1.05em;
  color: #333;
  line-height: 1.2;
  margin-bottom: 5px; }
  
.appDetail__ad-example {
  font-family: "SF UI", helvetica, arial, sans-serif;
  font-size: 0.75rem; }
        
.getButton__ad-example {
  position: relative;
  padding: 0.3rem 0.5rem;
  border: 1px solid #3E90F4;
  color: #3E90F4;
  font-size: 0.65rem;
  font-family: "SF UI", helvetica, arial, sans-serif;
  border-radius: 3px;
  line-height: 1; }
  .getButton__ad-example::before {
      content: '+';
      position: absolute;
      line-height: 1;
      font-size: 7px;
      font-weight: 400;
      top: 0;
      left: 1px; }

.adSymbol__ad-example {
  display: inline-block;
  padding: 0 5px;
  background: #8EC5FE;
  color: #fff;
  border-radius: 2px;
  margin-right: 8px; }
        
.publisher__ad-example {
  font-size: 0.9em;
  color: #666;
  line-height: 1.3;
  display: table;
  table-layout: fixed;
  width: 100%;
  white-space: nowrap; }

.publisher__ad-example > span {
  display: table-cell;
  overflow: hidden;
  text-overflow: ellipsis; }

.screenshotsContainer__ad-example {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
      justify-content: space-around;
  margin-top: 4.09%;
  width: 100%;
  padding-left: 10.3226%;
  padding-right: 10.3226%; }
  
  .screenshot__ad-example {
  width: 30%; }
  .screenshot__ad-example > img {
      width: 100%; }



  // app name 
  .blackSection {
    background-color: rgba(35, 31, 32, 1);
    color: #fff;
    position: relative;
    z-index: 12;
    .appDisplay__app-display {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center; }
}



.o-wrapper {
    padding-top: 16px;

    max-width: 1020px;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    margin-right: auto;
    margin-left: auto; }
    @media (min-width: 768px) {
      .o-wrapper {
        padding-right: 40px;
        padding-left: 40px; } }
    @media (min-width: 1281px) {
      .o-wrapper {
        max-width: 1120px;
        padding-right: 1.5rem;
        padding-left: 1.5rem; } }

.appDisplayImg__app-display {
    padding-right: 0.75rem; }
    .appDisplayImg__app-display > img {
      border: 1px solid #D8D8D8;
      width: 3.25rem;
      height: 3.25rem;
      max-width: none;
      border-radius: 1rem; }
    @media (min-width: 480px) {
      .appDisplayImg__app-display {
        padding-right: 1.5rem; }
        .appDisplayImg__app-display > img {
          width: 4.25rem;
          height: 4.25rem; } }
  
.appName__app-display,
.appLongName__app-display {
    margin-top: 0px;

    font-family: 'Montserrat';
    font-size: 22px;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    letter-spacing: 0.09em;
    /*Text styles for S */
    font-family: 'Montserrat';
    font-size: 22px;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    text-align: left;
}
    // @media (min-width: 480px) {
    //   .appName__app-display,
    //   .appLongName__app-display {
    //     font-size: 2rem; } }
    // @media (min-width: 1281px) {
    //   .appName__app-display,
    //   .appLongName__app-display {
    //     font-size: 2.25rem; } }
  
.appPublisher__app-display {
    font-family: 'Montserrat';
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    letter-spacing: 0.07em;
    margin-top: 8px;

}
.appPublisher__app-display > span {
    display: table-cell;
    overflow: hidden;
    text-overflow: ellipsis; }
@media (min-width: 480px) {
    .appPublisher__app-display {
    font-size: 1.2rem; } }
  
.appDisplayConcise__app-display .appDisplayImg__app-display {
padding-right: 0.75rem; }
.appDisplayConcise__app-display .appDisplayImg__app-display > img {
    width: 36px;
    height: 36px;
    border-radius: 5px; }
    // end of app name


.responsiveBlock {
  margin-bottom: 10px; 
  // width: 100%;  please use bootstrap element Row and Col instead

  @media (min-width: 768px) {
    // width: 48%; please use bootstrap element Row and Col instead
  }
  
  @media (min-width: 1200px) {
    // width: 24%; please use bootstrap element Row and Col instead
  }
}
  
  // -- Zay Modification
  .round-border-wrapper {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0; padding: 0;
    border: 1px solid rgba(255, 255, 255, 1);
    width: 210px; height: 40px;
    background-color: transparent;
    line-height: 40px;
    transition: .3s;
    border-radius: 20px;

    &.campaign-state { align-items: baseline; }

    p {
      display: inline-block;
      font-family: 'Montserrat';
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 0.08em;
    }
  }
  .round-border-wrapper:hover, .round-border-wrapper:focus {
    background-color: rgba(255, 255, 255, .2);
    opacity: 1;
  }

  .header {
    padding-right: 64px;
    padding-bottom: 13px;
    padding-left: 55px;

    .app {
      display: inline-flex;
      align-items: center;
      width: calc(100% - 210px);
      padding-right: 21px;

      dt {
        margin: 0;
        min-width: 85px;
        width: 85px;
        height: 85px;
        img { height: 78px; border-radius: 1rem; }
      }

      dd {s
        margin: 0; margin-left: 11px;
        padding: 0;
        
        h1 {
          margin: 0;
          font-family: 'Montserrat';
          font-size: 22px;
          font-weight: 300;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        h2 {
          margin: 0; margin-top: 8px;
          span { display: inline-block; }
          span:first-child {
            padding-right: 14px;
            border-right: 1px solid rgba(255, 255, 255, 1);
            font-family: 'Montserrat-Light';
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 0.07em;
          }
          span:last-child {
            padding-left: 14px;
            font-family: 'Montserrat-Light';
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      // -- .app
    }

    button.round-border-wrapper {
      p {
        overflow: hidden;
        white-space: nowrap;
      }
      .emulate-plus {
        margin-right: 12px;
        position: relative;
        display: inline-flex;
        width: 13px; height: 13px;
      }
      .emulate-plus:before, .emulate-plus:after {
        position: absolute;
        display: inline-block;
        content: '';
        background-color: rgba(255, 255, 255, 1);
      }
      .emulate-plus:before {
        top: 50%; right: 0; left: 0;
        height: 1px;
        transform: translateY(-1px);
      }
      .emulate-plus:after {
        top: 0; left: 50%; bottom: 0;
        width: 1px;
        transform: translateX(-1px);
      }
    }

    .header-controls {
      display: flex;
      align-items: center;
      border: 1px solid rgba(230, 230, 230, 0.5);
      padding: 19px 44px 20px 40px;
      border-radius: 7px;

      dl {
        margin: 0; padding: 0;
        flex-grow: 1;

        dt {
          font-family: 'Montserrat';
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 0.07em;
        }

        dd {
          font-family: 'Montserrat';
          font-size: 30px;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 0.08em;
        }
      }

      button {
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(255, 255, 255, 1);

        .emulate-plus { margin-right: 0; width: 8px; height: 8px; }
        p { margin-left: 10px; }
        img { margin-right: 12px; }
        img + p { margin-left: 0; }
      }
      button:not(:first-of-type) { margin-left: 24px; }
      button:first-of-type { width: 181px; }
      button:first-of-type + button { width: 161px; img { width: 10px; } }
      button:last-of-type { width: 160px; img { width: 13px; } }
    }
    // -- .header
  }

  .main {
    margin: 0;
    padding: 29px 64px 42px 55px !important;

    .charts > .chart-controls {
      display: flex;
      align-items: center;
      margin-bottom: 17px;

      .round-border-wrapper {
        border-color: rgba(151, 151, 151, 1);
        background-color: transparent;
        cursor: pointer;

        img { margin-right: 11px; }
        p, p a {
          font-family: 'Montserrat';
          font-size: 15px;
          color: rgba(35, 31, 32, 1);
          text-align: center;
          letter-spacing: 0.01em;
          overflow: hidden;
          white-space: nowrap;
        }
        p:only-child, a:only-child { display: block; width: 100%; line-height: 40px; text-decoration: none; }

        :not(.countries) { margin-left: 22px; }

        .dashboard-tooltip {
          position: absolute;
          top: -18px;
          right: -8px;
        }
      }
      .round-border-wrapper:hover, .round-border-wrapper:focus { background-color: rgba(100, 100, 100, .1); }

      .countries { width: 199px; }
      .download { width: 246px; img { height: 18px; } }

      .round-border-wrapper.date-range {
        position: relative;
        width: 314px;

        img { height: 21px; }
        .isoCalendarDatePicker {
          position: absolute;
          top: 0; right: 0; bottom: 0; left: 0;
          z-index: 999;
          
          .DateRangePicker { width: 100%; }
          .DateRangePickerInput {
            position: relative;
            width: 100%; height: 40px;
            overflow: hidden;
            opacity: 0;

            .DateInput:first-child {
              position: absolute;
              top: 0; right: 0; bottom: 0; left: 0;
              width: 100%;
              z-index: 999;

              p { display: none; }
            }
            input { cursor: pointer; }
          }

          .DateRangePicker_picker { margin-top: -28px; }
        }
      }

      // -- .chart-controls
    }

    .charts {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      // margin-bottom: 30px !important;

      > * {
        display: inline-block;
        margin: 0;
        padding: 0;
      }
      > :not(:last-child) {

        // NOTE: removed by tom : sorry nth child styling is not easy to be extended. please use class base styling instead
        // width: 24%;

        .isoSaleWidget {
          .isoSalePrice { line-height: 66px; font-size: 45px;}
          .isoSaleDetails { margin-top: 19px; img { margin-left: 7px; height: 14px; cursor: pointer; } }

          
        }
      }
      > :last-child { 
        // margin-top: 30px; 
        width: 100%; 
       
       }

      .isoExampleWrapper {
        margin-top: 0;
        .rc-tabs { width: 100%; }
      }
      .rc-tabs-nav {
        .rc-tabs-ink-bar { height: 0; opacity: 0; }
        .rc-tabs-tab {
          position: relative;
          flex-basis: auto !important;
          padding-right: 48px; padding-left: 40px;
          line-height: 38px;
          font-family: 'Montserrat';
          font-size: 12px;
          color: rgba(147, 147, 147, 1);
          letter-spacing: 0.08em;

          :before {
            position: absolute;
            top: 0; right: 0; left: 0;
            display: inline-block;
            content: '';
            height: 4px;
          }
        }
        .rc-tabs-tab:nth-child(2):before { background-color: rgba(71, 178, 170, 1); }
        .rc-tabs-tab:nth-child(3):before { background-color: rgba(93, 215, 255, 1); }
        .rc-tabs-tab:nth-child(4):before { background-color: rgba(236, 184, 92, 1); }
        .rc-tabs-tab:nth-child(5):before { background-color: rgba(114, 90, 166, 1); }

        .rc-tabs-tab-active { font-weight: 700; color: rgba(64, 55, 57, 1); }
      }

      .rc-tabs-content canvas { margin: 12px 29px 20px 40px; width: calc(100% - 69px) !important; height: 344px !important; }
      // -- charts
    }

    // .charts + * { 
    //   margin-bottom: 30px !important; 
    // }

    .iphone-container { .exampleAdPreview { padding-top: 11px; padding-bottom: 21px; } }
    .iphone-container .isoExampleWrapper {
      display: flex;
      justify-content: flex-end;
      margin-top: -13px;  

      .exampleHolder2 { display: none; }
      .exampleHolder {
        position: relative;
        width: 95%;

        .searchTerm__ad-example { top: 9.9%; }
        .container__ad-example { top: 15.4%; }
      }
    }

    .tap-through-container {
      display: flex;
      
      .tap-through-chart {
        max-width: 150px;
      }

      .isoWidgetsWrapper {
        margin: 0;
        width: 100%;
        padding: 0;

        .isoBoxWrapper {
          margin: 0;
          padding: 0;

          .isoExampleWrapper {
            position: relative;
            display: block;
            margin-top: 0;
            text-align: center;

            label {
              font-family: 'Montserrat';
              font-size: 14px;
              color: rgba(64, 55, 57, 1);
              text-align: left;
              letter-spacing: 0.04em;
              display: -webkit-inline-box;

              span {
                  display: inline-block;
                  margin-left: 4px;
                  border: 1px solid rgba(147, 147, 147, 1);
                  border-radius: 100%;
                  width: 14px; height: 14px;
                  line-height: 14px;
                  font-family: 'Montserrat';
                  text-align: center;
                  font-size: .7em;
                  color: rgba(147, 147, 147, 1);
              }
            }
            .percentage {
              position: absolute;
              top: 50%; left: 50%;
              transform: translateX(-50%) translateY(-50%);
            }
          }
        }
      }
      // -- .tap-through-container
    }

    .tracking-accounts {
      .isoWidgetsWrapper {
        margin: 0;
        margin-left: 10px;

        .isoWidgetBox {
          padding: 46px 38px 0 38px;
          height: auto !important;

          .isoExampleWrapper {
            margin-top: 0;

            .firstLine {
              font-family: 'Montserrat';
              font-size: 17px;
              color: rgba(64, 55, 57, 1);
              letter-spacing: 0.03em;
            }
            .secondLine {
              font-family: 'Montserrat';
              font-size: 17px;
              color: rgba(147, 147, 147, 1);
              text-align: center;
              letter-spacing: 0.03em;
            }
            .thirdLine {
              margin-top: 39px;
              text-align: center;

              img {
                margin-bottom: 35px;
                width: auto; max-width: none;
                max-height: none;
              }

              .acc-flyer,
              .acc-adjust,
              .acc-tune,
              .acc-kochava {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }

              .acc-flyer img { height: 41px; }
              .acc-adjust img { height: 75px; }
              .acc-tune img { height: 35px; }
              .acc-kochava img { height: 34px; }

              // -- .thirdLine
            }
          }
        }
      }
      // -- .tracking-accounts
    }
    // -- .main
  }

  @media screen and (max-width: 767px) {
    .header {
      margin-top: -1px;
      padding-top: 11px;
      padding-right: 16px;
      padding-left: 16px;

      .app {
        margin: 0; padding: 0;
        width: calc(100% - 30px);
        padding-right: 4px;

        dt { min-width: 64px; width: 64px; height: 64px; img { height: 64px; }}
        dd {
          margin-left: 13px;

          h1 {
            font-family: 'Montserrat';
            font-size: 22px;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            letter-spacing: 0.09em;
          }
          h2 {
            span:not(p):not(:only-child) {
              display: block;
              margin: 0; padding: 0;
              font-family: 'Montserrat';
              font-size: 12px;
              color: rgba(255, 255, 255, 1);
              text-align: left;
            }
            span:first-child:not(:only-child) { margin-bottom: 2px; border-width: 0; }
          }
        }

        ~ button {
          display: flex;
          position: relative;
          left: 100%;
          width: 26px; height: 26px;
          border-radius: 26px;
          transform: translateX(-100%);
  
          .emulate-plus { margin: 0 auto; }
          p { display: none; }
        }
        // -- .app
      }

      .header-controls {
        margin-top: 15px;
        padding: 19px 13px 18px 16px;

        .round-border-wrapper:not(:only-child):not(:first-child) {
          width: 40px; height: 40px;
          border-radius: 40px;

          :not(first-of-type) { margin-left: 6px; }
          img { margin: 0; }
          p { display: none; }
        }
      }
      // -- .header
    }

    .main {
      padding-right: 16px !important;
      padding-left: 16px !important;

      .charts {
        > :not(:last-child) { margin-bottom: 10px; width: 100%; }
        //> :last-child { display: none; }

        .chart-controls {
          flex-wrap: wrap;
          .round-border-wrapper:not(:only-child) {
            margin: 0;
            width: 100%;
            :first-of-type { margin-bottom: 14px; }
          }

          .download { display: none; }
        }
      }

      .tracking-accounts {
        .isoWidgetsWrapper {
          margin: 0;
          
          .isoWidgetBox {
            .isoExampleWrapper {
              .thirdLine {
                img { margin-bottom: 20px; }
            }
          }
        }
      }
    }
  }
  
  @media screen and (max-width: 480px) {
    .header .app dd h1 { font-size: 16px; }
    .header .app dd h2 > :not(p):not(:only-child):first-child { display: none; }

    .header .header-controls {
      dl dd { font-size: 21px; }

      .round-border-wrapper {
        position: relative;
        display: block;
        justify-content: unset;
        align-items: unset;
      }
      .round-border-wrapper > * {
        position: absolute !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      
      .add-budget > :first-child {
        transform: translate(-100%, -50%);

        + * { transform: translate(10%, -50%); }
      }
      
      .campaign-state > :first-child { left: 50%; }
    }
  }
  // -- /.Zay Modification

  // to make charts resusable , no need to put charts inside main
  // to make 
  




`;

export { WidgetWrapper, WidgetBox, WidgetColumn, DashboardWrapper };



// WEBPACK FOOTER //
// ./src/containers/Dashboard/style.js